webpackJsonp([90],{

/***/ 2395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsClients_vue__ = __webpack_require__(3389);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa668c5c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsClients_vue__ = __webpack_require__(4124);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4122)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fa668c5c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsClients_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa668c5c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsClients_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/openlegal/TermsClients.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fa668c5c", Component.options)
  } else {
    hotAPI.reload("data-v-fa668c5c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 4122:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4123);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("318a4c90", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-fa668c5c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TermsClients.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-fa668c5c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TermsClients.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4123:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-fa668c5c]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-fa668c5c],.slide-down-leave-active[data-v-fa668c5c]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-fa668c5c],.slide-down-leave-to[data-v-fa668c5c]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-fa668c5c],.slide-fade-left-leave-active[data-v-fa668c5c]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-fa668c5c],.slide-fade-left-leave-to[data-v-fa668c5c]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-fa668c5c]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-fa668c5c],.fade-leave-to[data-v-fa668c5c]{opacity:0\n}\npre[data-v-fa668c5c]{font-size:1.2rem;font-family:'Open Sans', sans-serif;line-height:1.5;margin:0;padding:0;white-space:pre-line\n}\n", ""]);

// exports


/***/ }),

/***/ 4124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-container", [
    _c("pre", { staticClass: "text-left" }, [
      _vm._v(
        "      Este acuerdo ha sido escrito en español (España). En caso de existir discrepancias entre el original y una versión traducida, el original en español es el documento vinculante.\n\n"
      ),
      _c("b", [_vm._v("Declaración de responsabilidades y de derechos.")]),
      _vm._v(
        "\n\nEsta Declaración de derechos y responsabilidades regula la relación de openlegal, y openlegal 360 (en adelante nos referimos a todas como openlegal), sus usuarios y los abogados, procuradores y otros profesionales que hacen uso de la web. Los individuos que acceden y utilicen openlegal están aceptando expresamente nuestros términos de servicio sin reserva alguna, en el caso de que se produjese reserva o renuncia alguna a los mismos, se entenderá que el usuario rechaza formar parte de la misma y se procederá a la baja de su usuario cuando dicha declaración sea expresada.\n\nPara obtener la condición de usuario de la presente web, es necesario ser usuario registrado de la misma, sometiéndose y aceptando expresamente con ello, todo lo dispuesto en estos Términos del Servicio.\n\nUtilizar la web, sus servicios con carácter general y otros contenidos con carácter particular, implica que el usuario se compromete a hacerlo con arreglo a lo dispuesto en la Ley, a lo estipulado en estos Términos del Servicio, y a lo establecido en otras instrucciones o normativas de uso que se establezcan y se pongan en conocimiento del usuario.\n\n"
      ),
      _c("b", [_vm._v("Alta de menores")]),
      _vm._v(
        "\n\nLa plataforma sólo permite el alta a usuarios mayores de edad (18 años en España). No obstante, los menores de edad pueden utilizarla a través del perfil de usuario creado para ellos por el padre, madre o tutor legal. Los menores en ningún caso podrán tener credenciales individuales de acceso a la plataforma, siendo obligatorio el acceso con el padre, madre o tutor legal. El usuario declara en todo momento que, tal y como consta en el formulario de registro, es mayor de 18 años.\n\n"
      ),
      _c("u", [_vm._v("1. Información legal corporativa")]),
      _vm._v(
        "\n\nEl titular del sitio web es la sociedad Open Legal S.L., empresa con domicilio sito en calle Puente Verde, 4 de Granada y CIF: B09621095 (en adelante, 'Openlegal'), Inscrita en el registro mercantil de Sevilla en el tomo 1798, folio 97, inscripción 1 con hoja GR-57852.\n\n"
      ),
      _c("u", [_vm._v("2. El Servicio de Openlegal")]),
      _vm._v(
        "\n\nOpenlegal es una plataforma para la gestión online de citas presenciales y no presenciales dentro del ámbito jurídico con despacho o profesionales privados así como la realización en su caso de consultas en un entorno virtual.\n\nEste servicio proporciona a los usuarios una plataforma on line que les permite solicitar una cita presencial o conectarse de manera virtual con abogados y profesionales del mundo del derecho. OpenLegal en ningún caso proporciona asesoramiento jurídico, ni recomendaciones o emite informes o dictámenes, ni presta servicios jurídicos a los clientes de ningún tipo. Si confía en cualquier información proporcionada a través de la plataforma o cualquier profesional que utiliza openlegal será bajo su propia responsabilidad.\n\nCredenciales e independencia de profesionales I\n\nLos profesionales que utilizan o aparecen en el sitio / aplicación no son empleados ni tienen ningún tipo de vinculación contractual como prestadores de servicios con OpenLegal, salvo en su caso, lo relativo a los servicios de asesoramiento jurídico para empresas. OpenLegal no proporciona opiniones, consejos ni atención jurídica y se exime de toda responsabilidad por las opiniones, consejos e información proporcionada por los profesionales a través de la plataforma. OpenLegal no recomienda ni aprueba ningún servicio, productos, procedimientos, opiniones u otra información que pueda mencionarse en OpenLegal o por un profesional.\n\nOpenLegal requiere que cada profesional proporcione a OpenLegal información personal y datos profesionales para acreditar su identidad y credenciales, antes de que OpenLegal permita que el profesional esté disponible en la plataforma. Cada Profesional debe estar colegiado en el correspondiente colegio oficial y tener en vigor las habilitaciones legales requeridas para ejercer su actividad. En este sentido el profesional autoriza expresamente a OpenLegal para que verifique en su caso sus datos con el Colegio Oficial que corresponda.\n\nAsimismo opensalud podrá utilizar los servicios de verificación externos que recoge la normativa vigente, en el caso de que el profesional requiera el uso de funcionalidades, como la receta electrónica por ejemplo, que requieran de elementos de seguridad adicionales.\n\nAl aceptar los términos del mismo, usted libera expresamente y descarga a OpenLegal de toda responsabilidad asociada con la veracidad o la verificación de la información que proporcionan los profesionales.\n\nLa inclusión de profesionales en nuestra plataforma no implica ninguna recomendación o aprobación de tales profesionales. Está prohibido el uso de la plataforma por cualquier entidad o individuo para verificar las credenciales de los profesionales.\n\nTodas las opiniones y afirmaciones expresadas por los profesionales en o a través de nuestra plataforma y durante cualquier sesión facilitada a través de la misma son exclusivamente las opiniones y declaraciones del Profesional, individuales e independientes, y no reflejan las opiniones de OpenLegal.\n\nOpenLegal no está cualificado para evaluar la calidad o validez de cualquier tipo de asesoramiento jurídico.\n\nPor tanto, en cualquier caso y con independencia del canal por el cual el cliente accede a los servicios del profesional, este mantendrá indemne y libre a OpenLegal de cualquier responsabilidad o reclamación de los Usuarios que esté relacionada con la prestación de los Servicios clínicos, responsabilizándose el profesional de cualquier indemnización que se derive de las mismas. En el caso de la atención jurídica a usuarios de empresas clientes de OpenLegal, el profesional declara expresamente que dispone de todas las habilitaciones legales, fiscales, administrativas, así como de los correspondientes seguros y permisos requeridos en su caso, para el ejercicio de su\n\nactividad en el sector privado. OpenLegal podrá requerir en cualquier momento que acredite documentalmente el cumplimiento de las citadas obligaciones.\n\nAl aceptar los términos del mismo, usted libera expresamente y descarga a OpenLegal de toda responsabilidad asociada con las consultas, el asesoramiento, recomendaciones u otra información que sea proporcionada por el profesional al cliente.\n\nPropiedad Intelectual de Openlegal\n\nOpenLegal por sí o como cesionaria, es titular de todos los derechos de propiedad intelectual e industrial de la web, así como de la estructura de programación de la misma, así como de los elementos contenidos en la misma (Sonido, audio, vídeo, imágenes, software y demás, sirviendo esto sólo a título ilustrativo) y de los cuales se reserva todos los derechos o bien, en su caso, el de sus licenciantes, quedando expresamente prohibido el uso por parte de terceros, conforme a la normativa vigente de Propiedad Intelectual (Real Decreto Legislativo 1/1996, de 12 de abril) sin que exista un consentimiento formal por parte de sus titulares. El usuario deberá abstenerse de suprimir, alterar, evitar o cambiar cualquier dispositivo de protección o sistema de seguridad que estuviera instalado en la web. En este sentido, la web se reserva el ejercicio de las acciones tanto penales como civiles que le amparen para hacer efectivo estos derechos frente a terceros.\n\nCredenciales e independencia de profesionales II\n\nNo obstante lo anterior, en el caso de los profesionales que presten servicios directamente a empresas clientes de opensalud, de manera previa al inicio de la prestación del servicio, los profesionales deberán aceptar expresamente las condiciones de prestación del servicio para opensalud.\n\nPara estos profesionales y de manera adicional a las comprobaciones previas realizadas por opensalud en el momento del registro, el profesional declara expresamente que dispone de todas las habilitaciones legales, fiscales, administrativas, así como de los correspondientes seguros y permisos requeridos en su caso, para el ejercicio de su actividad profesional. Opensalud podrá requerir que acredite el cumplimiento de las citadas obligaciones.\n\nEl profesional asume el compromiso de facilitar la correcta atención a todos los usuarios del servicio, así como a notificar a opensalud con la mayor brevedad posible cualquier incidencia que le impida garantizar la adecuada prestación de los servicios (vacaciones…).\n\nOpensalud trasladará al profesional cualquier queja recibida por la calidad del servicio, que deberá ser contestada en un máximo de 48 horas desde su recepción.\n\n"
      ),
      _c("u", [_vm._v("3. Exclusión de garantías y responsabilidad")]),
      _vm._v(
        "\n\nLa web OpenLegal no se hace responsable de los daños derivados del uso de la web por usos o gestiones con la misma de forma indebida, así como por los usos comunes de estos, siempre que haya existido por parte de la misma las diligencias debidas para que estos no se produzcan. A su vez, dado su carácter de plataforma de interconexión de profesionales y usuarios, se exime de cualquier responsabilidad asociada por las consultas, recomendaciones o cualquier actividad que vincule a ambas partes.\n\n"
      ),
      _c("u", [_vm._v("4. Modificaciones")]),
      _vm._v(
        "\n\nOpenlegal se reserva el derecho de realizar las modificaciones que se estimen oportunas sin previo aviso en su web, pudiendo modificar, eliminar o introducir tanto contenidos como servicios que se presten por las mismas, así como la disposición u organización de los mismos en la web.\n\n"
      ),
      _c("u", [
        _vm._v("5. Tu información en Openlegal y su manera de ser compartida")
      ]),
      _vm._v(
        "\n\nLos datos e información de los usuarios de Openlegal son privados. Los datos registrados en la\n\nweb deben de tener autenticidad, es decir, ser reales a los efectos de poder dar un servicio correcto. En caso de falsedad de dicha información, Openlegal se exonera de cualquier daño o responsabilidad que pueda generar la misma.\n\na) Una vez registrado en la web, pasas a ser usuario, no obstante, dichos datos sólo son accesibles para Openlegal, así como para los profesionales y despachos con los que solicites cita en cualquiera de sus modalidades.\n\nb) Aquella información que compartas será accesible por los profesionales y en su caso el despacho al que pertenezcan, a los efectos de garantizar una correcta atención y velar por la calidad en la prestación de los servicios y en ningún caso será facilitada a terceros ajenos a la prestación del servicio solicitado por el usuario. En cualquier momento podrás revocar esta autorización de manera directa y automática.\n\n"
      ),
      _c("u", [
        _vm._v("6. Tus derechos de imagen y Propiedad Intelectual en Openlegal")
      ]),
      _vm._v(
        "\n\nAl publicar contenido como imágenes audiovisuales, fotografías y textos que estén sujetos a derechos de propiedad intelectual (en adelante, 'Contenido Sujeto a Propiedad Intelectual'), otorgas a Openlegal la posibilidad de usar los mismos bajo una licencia no exclusiva, transferible y sin posibilidad de ser subotorgada, sin comisión u otra necesidad de ofrecer cualquier remuneración a su autor por el uso, y alcance internacional (en adelante, 'Licencia de Propiedad Intelectual'). Es decir, autorizas para que la plataforma haga uso de la misma, pero en ningún caso, que realice actividad comercial directa a través de la venta o cesión de dichos contenidos a terceros para el propio funcionamiento de la misma.\n\n"
      ),
      _c("u", [_vm._v("7. Uso de los contenidos")]),
      _vm._v(
        "\n\nDesde la web se facilitan distintas informaciones y enlaces que pueden resultar de interés para el usuario, el cual se compromete a hacer un uso adecuado de los contenidos y servicios que las mismas le ofrecen y con carácter enunciativo, pero no limitativo, a no emplearlos para las siguientes actividades:\n\n1. Incurrir en actividades ilícitas, ilegales o contrarias a la buena fe y al orden público a través de los mismos.\n\n2. Provocar cualquier tipo de daño en los sistemas propios de la web, de sus proveedores o terceras personas, ingresar o difundir en la red virus informáticos, troyanos o cualesquiera otros sistemas que sean susceptibles o hábiles de generar los referidos daños.\n\n3. Realizar cualquier tipo de actividad que pueda ser contraria al derecho al honor de cualquiera de los usuarios o administradores de OpenLegal.\n\n4. Llevar a cabo la actividad profesional con la que se da de alta sin la titulación\n\n"
      ),
      _c("u", [_vm._v("8. La seguridad en Openlegal")]),
      _vm._v(
        "\n\nNuestro equipo trabaja a diario para asegurarse que OpenLegal sea una plataforma segura, respetando la protección de datos de los Usuarios Registrados. Sin embargo, como cualquier otra plataforma web la protección de datos no puede garantizarse de\n\nmanera absoluta y en cualquier circunstancia. No obstante, para cumplir con dicha protección con la mayor seguridad posible, los Usuarios Registrados entienden que queda expresamente prohibido:\n\na) La transmisión y difusión de cualquier tipo de comunicación comercial no autorizada (como 'spam' o 'correo no deseado') utilizando cualquier herramienta de comunicación que OpenLegal ofrezca a los Usuarios Registrados.\n\nb) Acceder a OpenLegal de otra forma que no sea a través de un navegador, aplicación móvil oficial o cualquier herramienta que agreguemos oficialmente en el futuro y sea notificada a los Usuarios.\n\nc) El uso de medios de acceso automáticos (como cualquier uso de tecnología conocidas como bots, robots, arañas) que realicen una interacción dentro de la plataforma de OpenLegal y con cualquiera de los Usuarios Registrados.\n\nd) La práctica y la participación en cualquier tipo de operación de marketing ilegal a través de OpenLegal.\n\ne) Cargar virus, scripts, ni cualquier tipo de código con aspiraciones malintencionadas en contra de OpenLegal y cada uno de sus Usuarios Registrados.\n\nf) La solicitud de información de registro y de inicio de sesión para acceder a la cuenta de propiedad de otro individuo.\n\ng) El acoso, agobio, intimidación o cualquier tipo de molestia a cualquiera de los Usuarios Registrados.\n\nh) La publicación de cualquier contenido que resulte ofensivo, chantajista o pornográfico; o que incite a la violencia; o que contenga desnudos o violencia gráfica injustificada.\n\ni) El desarrollo o uso de aplicación a terceros que incluyan contenidos relacionado con el consumo de alcohol o de naturaleza adulta (incluidos anuncios) sin las restricciones de edad apropiadas a la región determinada.\n\nk) Utilizar OpenLegal para cualquier tipo de actividad ilegal, ya sea contra la propia red, cómo contra cualquier usuario, entendiendo por ello cualquier acto que contravenga la normativa española, en especial aquellos que vulneren los derechos a la privacidad y/ o honor de los usuarios de esta red.\n\nl) Cualquier actividad que pueda desactivar, sobrecargar o impedir el funcionamiento correcto de OpenLegal, como un ataque de denegación de servicio.\n\nm) Motivar directa o indirectamente la violación de esta Declaración.\n\n"
      ),
      _c("u", [_vm._v("9. Seguridad de la cuenta y registro")]),
      _vm._v(
        "\n\nLos Usuarios están obligados a facilitar sus nombres reales e información real. Entienden que queda expresamente prohibido:\n\n1. Compartir la información de acceso (usuario y contraseña; o clave secreta en el caso de programadores) para que otra persona acceda a tu cuenta o cualquier actividad que ponga en peligro la seguridad de tu cuenta y la de los demás.\n\n2. Transferir tu cuenta a otra persona bajo ningún concepto, dado el carácter profesional de la misma.\n\n"
      ),
      _c("u", [_vm._v("10. Precio y condiciones de pago")]),
      _vm._v(
        "\n\nEl acceso a la web de Openlegal es de naturaleza gratuita. Respecto a la concertación de citas y realización de las mismas a través o no de la plataforma, las mismas serán tarificadas y facturadas por\n\nparte de los profesionales que prestan sus servicios utilizando la plataforma conforme a los precios libremente establecidos por los profesionales y conocidos por el usuario en el momento de su solicitud.\n\nCon la excepción de los servicios de asesoramiento jurídico para empresas, en los cuales estas asuman integramente el coste, para garantizar la prestación de los servicios de teleconsulta (videoconsulta, consulta escrita o la que corresponda), es necesario introducir un medio de pago a la hora de reservar una cita, solicitar una videoconsulta inmediata realizar una solicitud de segunda opinión o consulta escrita. No obstante, no se realizará ningún cargo hasta que la teleconsulta haya finalizado.\n\nAsimismo, el cliente/usuario podrá cancelar su solicitud de videoconsulta sin ningún coste, en cualquier momento con una antelación mínima de 15 minutos sobre la hora de la cita programada. En el caso de las solicitudes de consulta escrita, chat o segunda opinión podrá cancelarlas hasta el momento en el cual el profesional acepta la solicitud.\n\nDado que la normativa aplicable a comercio electrónico y medios de pago exige especificarlo, es obvio que considerando las características del servicio no existe posibilidad de devolución del mismo.\n\nEn el caso de que el cliente no estuviese conforme con el servicio prestado deberá contactarnos utilizando el formulario que aparece en el pie de la página web y seleccionando la opción reclamación. Una vez evaluada, esta será respondida en un plazo máximo de 72 horas (laborables) y en el caso de estimarla favorablemente, en un máximo de 10 días le será reembolsado el coste del servicio utilizando el mismo medio de pago.\n\nEn relación a los servicios openlegal prime, el periodo mínimo de contratación será de 3 meses. Estos servicios son prestados por la empresa ……….\n\n"
      ),
      _c("u", [
        _vm._v("11. Suspensión del servicio o de la cuenta de usuario")
      ]),
      _vm._v(
        "\n\nSi se realiza alguna infracción de los puntos expresados en esta Declaración, Openlegal se reserva el derecho de la cancelación inmediata sin previo aviso de tu cuenta en Openlegal.\n\n"
      ),
      _c("u", [_vm._v("12. Privacidad")]),
      _vm._v(
        "\n\nA.- General\n\n¿Quién es el responsable del tratamiento de sus datos?\n\nOpen Legal S.L. (En adelante OpenLegal) Dirección Postal: Calle Puente Verde, 4 de Granada. Correo electrónico: soporte@openlegal.es\n\nPara posibilitar la navegación a través de la web es imprescindible ser usuario registrado y aceptar las reglas de privacidad que a continuación se detallan. Con el registro aceptas que Open Legal almacene y trate los datos personales que nos facilitas de acuerdo con la política de privacidad.\n\nLos datos personales proporcionados se conservarán mientras el usuario permanezca activo en la plataforma (no haya solicitado su baja) y durante los plazos necesarios para dar cumplimiento a las obligaciones legales relativas a la custodia de Información clínica y administrativa.\n\nLa base legal para el tratamiento de sus datos es el consentimiento del interesado. El tratamiento de los datos se realiza con las siguientes finalidades:\n\n- Vigilancia y salvaguarda del cumplimiento de una conducta adecuada y ética por parte de los usuarios.\n\n- Realización de estudios estadísticos e históricos por parte de OpenLegal. Los informes generados serán siempre agregados y anónimos.\n\n- Realización de comunicaciones de interés para los usuarios relativas al funcionamiento de la plataforma (sugerencias de utilización, mejoras introducidas…).\n\n- Envío de comunicaciones electrónicas a las que previamente se haya suscrito el usuario.\n\n- Envió mensual por email de un resumen de los artículos jurídicos más leídos en nuestro blog.\n\n- Realización de las consultas jurídicas y gestión de citas y servicios objeto de la actividad de la plataforma.\n\nNuestra política con respecto al envío de nuestros propios correos electrónicos se centra en remitir únicamente comunicaciones que usted haya solicitado recibir. Si prefiere no recibir estos mensajes por correo electrónico le ofreceremos a través de los mismos la posibilidad de ejercer su derecho de supresión y renuncia a la recepción de estos mensajes.\n\nTodos los usuarios que establezcan algún tipo de comunicación, bien a través de los formularios ubicados la Web, bien a través de vías alternativas, deben conocer que sus datos podrán ser recogidos para su tratamiento por parte de la presente plataforma.\n\nOpenLegal trata los datos de forma confidencial y adopta las medidas técnicas y organizativas apropiadas para garantizar el nivel de seguridad adecuado al tratamiento, en cumplimiento de lo requerido en la normativa aplicable en materia de Protección de Datos.\n\nNo obstante, ningún sistema puede garantizar la absoluta invulnerabilidad de los sistemas, por tanto, OpenLegal no asume ninguna responsabilidad por los daños y perjuicios derivados de alteraciones que terceros puedan causar en los sistemas informáticos, documentos electrónicos o ficheros del usuario.\n\nB. Cesión de datos\n\nCualquier dato que sea recogido por Open Legal bajo ningún concepto, será cedido a terceras empresas en ningún caso, salvo las excepciones que a continuación se desglosan:\n\n- Medie solicitud previa por parte del portal al interesado y este exprese su conformidad ya sea dicha solicitud con carácter individual o genérico. En todo caso Open Legal nunca cederá ningún dato con fines publicitarios.\n\n- Cuando se refieran a las excepciones contempladas por la normativa aplicable.\n\n- A través de la contratación con empresas terceras, para servicios de análisis, con fines exclusivamente estadísticos y de mejora del Servicio y nunca publicitarios.\n\n- A los profesionales de la abogacía registrados en la plataforma a los efectos de la concertación y realización de las citas jurídicas. A estos efectos, los profesionales y despachos registrados que accedan a los datos de clientes en la plataforma, asumen en su caso las obligaciones determinadas por la normativa sobre protección de datos aplicable, asumiendo toda la responsabilidad en caso de incumplimiento de dicha norma.\n\nConforme a dicha normativa, los profesionales y despachos, aceptan la relación como encargado del tratamiento con respecto a los datos personales que los usuarios registrados facilitan a OpenLegal a los efectos de realizar las citas y consultas, manteniendo en todo caso el nivel de datos especialmente protegidos para dicha información.\n\nEn relación a cualquier información extraída de la plataforma, por lo medios legalmente habilitados, el profesional/despacho debe conocer que los datos legales están catalogados como información muy sensible y de nivel alto de seguridad; y consecuentemente deberán tratarse siguiendo las directrices marcadas por el Reglamento (UE) 2016/679 Del Parlamento Europeo y del Consejo de 27 de abril de 2016 relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos y por el que se deroga la Directiva 95/46/CE (RGPD), la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales, y demás normativa vigente en materia de protección de datos de carácter personal y seguridad de la información. Únicamente podrá acceder o descargar aquella información a la que esté autorizado de acuerdo a la normativa vigente.\n\nEn ningún caso la información extraída se puede almacenar en el disco duro de los equipos (local). En caso de impresión de la información en papel, ésta deberá estar custodiada en todo momento por la persona responsable de la misma, y almacenarse bajo llave cuando no se esté haciendo uso de ella. Igualmente, no se debe hacer uso de dispositivos móviles externos para el almacenamiento y traslado de la información, tipo pendrive, smartphone, ordenadores portátiles, etc. En ningún caso se utilizará correo electrónico externo para el envío o recepción de este tipo de información. Asimismo, independientemente del soporte en que se encuentre, la información extraída, deberá de ser borrada o destruida fehacientemente una vez que haya dejado de ser necesaria para los fines que motivaron su extracción.\n\n- A las empresas que son utilizadas como soporte para el correcto funcionamiento de la plataforma (cloud, legal, encriptación…).\n\n- En el caso de los servicios de asesoramiento para empresas, para generar informes agregados de utilización de la plataforma por parte de sus empleados. Estos informes agregados serán anónimos y únicamente contendrán la siguiente Información: número total de usuarios, número total de servicios utilizados y principales motivos de consulta. Los datos se agregarán por sexo y tramos de edad.\n\n- En el caso de los servicios financiados por compañías aseguradoras, se cederán los datos para garantizar la calidad y la correcta prestación de los servicios y acreditar el nivel de utilización de la póliza por parte del asegurado.\n\nC. Calidad de los datos\n\nLa Web comunica a los usuarios la obligación de la correcta actualización de los datos facilitados y tratados en el fichero denominado Usuarios. Dichos datos deberán ser adecuados, pertinentes, actuales, exactos y verdaderos. Quedando excluido open Legal de todas aquellas consecuencias negativas derivadas de inexactitudes en los mismos.\n\nA su vez, se comunica a los usuarios, la imposibilidad de inscribir y/o comunicar datos de terceros en su nombre, por medio de las formas de comunicación estipuladas, salvo que exista una representación legalmente constituida. En el supuesto de menores, podrá requerirse la acreditación expresa de dicha condición.\n\nD. Derechos de acceso, oposición, rectificación y cancelación de datos, supresión y portabilidad.\n\nCualquier persona tiene derecho a obtener información sobre si en Open Legal estamos tratando sus datos personales.\n\nLas personas legitimadas tienen derecho a acceder a sus datos personales, a solicitar la rectificación de los datos inexactos o, en su caso, solicitar su eliminación cuando,\n\nentre otros motivos, los datos ya no sean necesarios para los fines que fueron recogidos.\n\nCuando las circunstancias así lo requieran, los interesados podrán solicitar la limitación del tratamiento de sus datos, en cuyo caso únicamente los conservaremos para el ejercicio o la defensa de reclamaciones.\n\nCuando precisemos obtener información por su parte, siempre le solicitaremos su consentimiento expreso a través de los medios habilitados para ello.\n\nEl ejercicio de estos derechos deberá llevarse a cabo mediante comunicación dirigida a Open Legal, ya sea a su dirección postal, indicada más arriba, o a la dirección electrónica dispuesta a estos efectos (soporte@openlegal.es), sin perjuicio del uso de cualquier otro medio válido en derecho, que permita cumplimentar de forma legalmente válida, los requisitos para ello.\n\nLos requisitos de contenido para el ejercicio de los derechos son:\n\n- Nombre y apellidos del interesado; copia de DNI, pasaporte o similar y, en su caso, de la persona que lo represente.\n\n- Objeto de la petición.\n\n- Dirección a efectos de notificaciones, fecha y firma del solicitante.\n\n- Documentos acreditativos de la petición formulada en el caso de que se estimen convenientes o necesarios.\n\nE. Agencia Española de Protección de Datos\n\nLos datos de los usuarios de la Web son incluidos en nuestros ficheros registrados en su día, ante la Agencia Española de Protección de Datos (AEPD) a nombre de Open Legal S.L con CIF B09621095. El RGPD que ha sustituido a la LOPD, ha suprimido la obligación de inscribir los ficheros en la AEPD. La AEPD es la encargada de velar por el cumplimiento de las leyes sobre privacidad y protección de datos y de garantizar la seguridad y privacidad de tus datos en general y especialmente en Internet.\n\nLos datos que aportas a la Web son incluidos en nuestros ficheros registrados ante la AgenciaEspañola de Protección de Datos (AEPD) a nombre de Open Legal S.L con CIF B09621095. La AEPD es la encargada de velar por el cumplimiento de las leyes sobre privacidad y protección de datos y de garantizar la seguridad y privacidad de tus datos en general y especialmente en Internet.\n\nEn caso de que sienta vulnerados sus derechos en lo concerniente a la protección de sus datos personales, especialmente cuando no haya obtenido satisfacción en el ejercicio de sus derechos, puede presentar una reclamación ante la Autoridad de Control en materia de Protección de Datos competente a través de su sitio web: www.agpd.es\n\nF. Enlaces de Interés\n\nSi queréis saber más acerca de Internet y vuestra privacidad desde OpenLegal os recomendamos que visitéis los siguientes enlaces para saber más sobre la misma: Oficina Seguridad Internet: http://www.osi.es Agencia Española de Protección de Datos: http://www.agpd.es\n\n"
      ),
      _c("u", [_vm._v("13. Asuntos Legales")]),
      _vm._v(
        "\n\nOpenLegal se atiene a la legislación aplicable en España y con ello a los tribunales que sean competentes en caso de conflicto, quedando a disposición del consumidor la selección del mismo.\n\nDefiniciones\n\n1. 'OpenLegal' se refiere al servicio que proporcionamos a través de la web para la gestión de consultas.\n\n2. 'Plataforma' se refiere a las API y servicios que permiten que otros, incluidos los desarrolladores de aplicaciones y operadores de sitios web, recuperen datos de OpenLegal y nos proporcionen datos.\n\n3. “Información' se refiere a cualquier dato o información sobre tu persona como usuario.\n\n4. 'Contenido' se refiere a cualquier cosa que publiques en OpenLegal que no se incluya en la definición de 'información'.\n\n5. 'Datos' se refiere al contenido y la información que un tercero pueda recuperar de OpenLegal.\n\n6. 'Publicar' significa publicar en OpenLegal.\n\n7. 'Usar' se entiende utilizar, copiar, reproducir o mostrar públicamente, distribuir, modificar, traducir y crear obras derivadas.\n\n8. “Beneficios” Todo aquel premio, descuento, promoción o similar que se facilita a los usuarios de la web.b.\n    "
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fa668c5c", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/90.e907680c355a211a69c3.js